import React from 'react'

import { useSelector } from 'react-redux'

import App from 'components/App/App'
import Login from 'components/Auth/Login/Login'
import ChangePassword from 'components/Auth/ChangePassword/ChangePassword'
import EmailChallenge from 'components/Auth/EmailChallenge/EmailChallenge'
import RecoveryPassword from 'components/Auth/RecoveryPassword/RecoveryPassword'

import {
  updateAuthData,
  LOGED_OUT,
  CHANGE_PASSWORD_CHALLENGE,
  EMAIL_VERIFICATION_CHALLENGE,
  RECOVERY_PASSWORD,
} from 'store/auth/auth'
import { getEnv } from 'configurations'

function AppAuthFLow() {
  const authData = useSelector((state) => state.auth.authData)

  if (authData.authStatus === LOGED_OUT) {
    return <Login />
  } else if (authData.authStatus === CHANGE_PASSWORD_CHALLENGE) {
    return <ChangePassword />
  } else if (authData.authStatus === RECOVERY_PASSWORD) {
    return <RecoveryPassword />
  } else if (authData.authStatus === EMAIL_VERIFICATION_CHALLENGE) {
    return <EmailChallenge />
  } else {
    return <App />
  }
}

export default AppAuthFLow
